/*
  COMPONENT: ProductPage
  PURPOSE: Displays a product page section with full product info
*/
import React from 'react'
import styled from 'styled-components'

// components
import ProductBlock from './ProductBlock'
import CaseProductBlock from './CaseProductBlock'

// styles
const Section = styled.section`
  background-color: ${(props) =>
    props.$productType === 'cases'
      ? props.theme.backgroundCasesDarker
      : 'inherit'};
`
const Container = styled.div`
  margin: 0 auto;
  padding-top: 15px;
  max-width: ${(props) => props.theme.containerWidth};
`

// view
const ProductPage = ({ product, category }) => (
  <Section $productType={product.type}>
    <Container>
      {product.type === 'cases' ? (
        <CaseProductBlock product={product} />
      ) : (
        <ProductBlock product={product} />
      )}
    </Container>
  </Section>
)

export default ProductPage
